import { render, staticRenderFns } from "./secret.vue?vue&type=template&id=62863172&scoped=true"
import script from "./secret.vue?vue&type=script&lang=js"
export * from "./secret.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62863172",
  null
  
)

export default component.exports